module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_9005.45dcaaf8.png";